import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { CustomValidators } from '../../../core/utils/custom-validators';
import { DynamicFormFieldModel } from '../../../models/dynamic-form-field.model';
import { DynamicFormFieldTypeEnum } from '../../../models/enums/dynamic-form-field-type.enum';
import { DynamicValidationTypeEnum } from '../../../models/enums/dynamic-validation-type.enum';
import { EntityTypeEnum } from '../../../models/enums/entity-type.enum';

@Component({
    selector: 'sl-dynamic-form-field',
    templateUrl: './dynamic-form-field.component.html',
    styleUrls: ['./dynamic-form-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DynamicFormFieldComponent implements OnInit {
    @Input() formField: DynamicFormFieldModel;
    @Input() control: FormControl;

    DynamicFormFieldTypeEnum = DynamicFormFieldTypeEnum;
    EntityTypeEnum = EntityTypeEnum;

    ngOnInit(): void {
        this.handleValidators();
    }

    private handleValidators(): void {
        if (!this.control || !this.formField.validators) {
            // can only add validators if there is a formControl attached
            return;
        }

        for (const validator of this.formField.validators) {
            switch (validator.type) {
                case DynamicValidationTypeEnum.Required:
                    this.control.addValidators(Validators.required);
                    break;
                case DynamicValidationTypeEnum.MinValue:
                    this.control.addValidators(CustomValidators.number({ min: validator.value }));
                    break;
                case DynamicValidationTypeEnum.MaxValue:
                    this.control.addValidators(CustomValidators.number({ max: validator.value }));
                    break;
                case DynamicValidationTypeEnum.Range:
                    this.control.addValidators(
                        CustomValidators.number({
                            min: Number(validator.value.min),
                            max: Number(validator.value.max)
                        })
                    );
                    break;
                case DynamicValidationTypeEnum.Email:
                    this.control.addValidators(Validators.email);
                    break;
            }
        }

        if (this.formField.type === DynamicFormFieldTypeEnum.Integer) {
            this.control.addValidators(CustomValidators.number({ isInteger: true }));
        }
    }
}
